import { useState } from "react";
import { getReviewerInitial } from "./reviewUtils";
import styles from "./ReviewAvatar.module.css";

export default function ReviewAvatar({
  imageUrl = "",
  name = "",
  className = "",
  size,
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const hasImage = Boolean(String(imageUrl || "").trim()) && !imageFailed;
  const initial = getReviewerInitial(name);

  if (hasImage) {
    return (
      <img
        src={imageUrl}
        alt=""
        width={size}
        height={size}
        className={className}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <span className={`${styles.fallback} ${className}`.trim()} aria-hidden="true">
      {initial}
    </span>
  );
}
